// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__geWrR","selected":"Chip_selected__2g0hv"};